module.exports = __webpack_public_path__ + "static/media/icon_8.839ca0de.png";